/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { checkFormHasError, getFormHelperText, handleChangeFormField } from 'ui/forms/formHelpers';
import { useField } from 'formik';
import SwitchField, { SwitchFieldProps } from 'ui/SwitchField/SwitchField';

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const FormSwitchField: React.FunctionComponent<React.PropsWithChildren<SwitchFieldProps>> = ({
  helperText,
  ...rest
}) => {
  const [field, meta] = useField(rest as any);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormField(field, event, rest.onChange as any);

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <SwitchField
      checked={field.value}
      error={hasError}
      helperText={helperTextValue as string}
      {...rest}
      onChange={handleChange}
    />
  );
};

export default FormSwitchField;
